import React from 'react'
import { Grid, Paper, Box } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

export function WorkflowRecipeSkeleton({ count = 6 }) {
  const items = Array.from({ length: count })

  return (
    <Grid container spacing={2}>
      {items.map((_, idx) => (
        <Grid item xs={12} sm={6} key={idx}>
          <Paper
            elevation={0}
            style={{
              border: '1px solid #E5E7EB',
              borderRadius: 10,
              padding: 18,
              height: '100%',
              boxSizing: 'border-box',
              backgroundColor: '#FFFFFF',
            }}
          >
            {/* Top row: Category & Status */}
            <Box display='flex' justifyContent='space-between' alignItems='center' mb={1.5}>
              <Skeleton variant='rect' width={100} height={22} style={{ borderRadius: 11 }} />
              <Skeleton variant='rect' width={85} height={22} style={{ borderRadius: 11 }} />
            </Box>

            {/* Title */}
            <Skeleton variant='text' width='65%' height={28} style={{ marginBottom: 6 }} />

            {/* Description lines */}
            <Skeleton variant='text' width='95%' height={18} />
            <Skeleton variant='text' width='75%' height={18} style={{ marginBottom: 12 }} />

            {/* Chips row */}
            <Box display='flex' style={{ gap: 6 }} mb={2}>
              <Skeleton variant='rect' width={90} height={24} style={{ borderRadius: 12 }} />
              <Skeleton variant='rect' width={110} height={24} style={{ borderRadius: 12 }} />
              <Skeleton variant='rect' width={70} height={24} style={{ borderRadius: 12 }} />
            </Box>

            {/* Button */}
            <Skeleton variant='rect' width='100%' height={34} style={{ borderRadius: 6 }} />
          </Paper>
        </Grid>
      ))}
    </Grid>
  )
}
